import { render, staticRenderFns } from "./StudentStatisticsOverview.vue?vue&type=template&id=a893d8ba&scoped=true"
import script from "./StudentStatisticsOverview.vue?vue&type=script&lang=js"
export * from "./StudentStatisticsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a893d8ba",
  null
  
)

export default component.exports